import React,{useEffect,useState} from "react";
import { Pagination, Table,Button } from "rsuite";

import "rsuite/dist/rsuite-no-reset.min.css";
import { Application} from "../../../common.interface";

const { Column, HeaderCell, Cell } = Table;
export interface ApplicationTableProps{
    data:Application[],
    myFunction:any,
    loading:boolean,
    actionText:string,
}

export default function CustomApplicationTable({ data,myFunction,loading,actionText}:ApplicationTableProps) {
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = (dataKey: number) => {
    setPage(1);
    setLimit(dataKey);
  };


  const newData = data.filter((_:any,i:any) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });


  const ButtonCell = ({ rowData, dataKey, ...props }:{rowData:any,dataKey:string}) =>(
    <Cell {...props}>
      <Button onClick={()=>myFunction(rowData[dataKey])} appearance={rowData['approver']['status']==='pending'?"primary":"default"} color="orange">{rowData['approver']['status']==='pending'?actionText:rowData['approver']['status']}</Button>
    </Cell>
  );

  return (
    <div className=" mt-2">
      <Table autoHeight data={newData} virtualized loading={loading} >
        <Column minWidth={150} flexGrow={2} align="left" fullText={true} fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell dataKey="name" />
        </Column>

        <Column minWidth={80} flexGrow={1} align="left" fullText={true}>
          <HeaderCell>Amount</HeaderCell>
          <Cell dataKey="amount" />
        </Column>

        <Column minWidth={80} flexGrow={1} align="left" fullText={true}>
          <HeaderCell>Date</HeaderCell>
          <Cell dataKey="createdAt" />
        </Column>

        <Column width={90} align="left" fixed="right">
          <HeaderCell>Action</HeaderCell>
          <ButtonCell dataKey='_id' rowData={newData} />
        </Column>

      </Table>
      <div style={{ padding: 20, width: "100%" }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={data.length}
          limitOptions={[20, 30, 50]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}

// const TableWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
//   align-items: center;
//  width:fit-content
// `;